var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12C14.5 10.7277 13.4905 9.69231 12.25 9.69231C11.0095 9.69231 10 10.7277 10 12C10 13.2723 11.0095 14.3077 12.25 14.3077C13.4905 14.3077 14.5 13.2723 14.5 12ZM14.5 4.30769C14.5 3.03538 13.4905 2 12.25 2C11.0095 2 10 3.03538 10 4.30769C10 5.58 11.0095 6.61538 12.25 6.61538C13.4905 6.61538 14.5 5.58 14.5 4.30769ZM14.5 19.6923C14.5 18.42 13.4905 17.3846 12.25 17.3846C11.0095 17.3846 10 18.42 10 19.6923C10 20.9646 11.0095 22 12.25 22C13.4905 22 14.5 20.9646 14.5 19.6923Z",
    fill: "#353A41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.10db399f31fcab7ce530344e1baa7359.svg";
export { ForwardRef as ReactComponent };